import React from 'react';

import {
  Alert,
  Box,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import TaskGridPanel from './TaskGridPanel';
import BudgetLineGridPanel from './BudgetLineGridPanel';

type Props = {
  taskRows: any[];
  budgetRows: any[];
  loading?: boolean;

  canPlan?: boolean;
  onPlanTasks?: () => void;
};

type State = {
  selectedTask: any | null;
};

class ActivityTaskBudgetPanel
  extends React.Component<Props, State> {

  state: State = {
    selectedTask: null,
  };

  private getTaskId = (row: any) =>
    row?.taskplanid
    || row?.rid
    || row?.id;

  componentDidUpdate(prevProps: Props) {
    const { selectedTask } = this.state;

    if (!selectedTask)
      return;

    const current = (this.props.taskRows || []).find(
      (row: any) =>
        String(this.getTaskId(row))
        === String(this.getTaskId(selectedTask)),
    );

    if (!current) {
      this.setState({
        selectedTask: null,
      });

      return;
    }

    /*
     * Refresh selected row reference after workbench reload.
     */
    if (current !== selectedTask) {
      this.setState({
        selectedTask: current,
      });
    }
  }

  private selectTask = (
    selectedTask: any | null,
  ) => {
    this.setState({
      selectedTask,
    });
  };

  private visibleBudgetRows = () => {
    const { selectedTask } = this.state;

    if (!selectedTask)
      return [];

    const taskplanid =
      this.getTaskId(selectedTask);

    return (this.props.budgetRows || []).filter(
      (row: any) =>
        String(row.taskplanid)
        === String(taskplanid),
    );
  };

  render() {
    const { selectedTask } = this.state;

    return (
      <Box>
        <Paper elevation={0} sx={{ p: 0 }}>
          <TaskGridPanel
            rows={this.props.taskRows || []}
            loading={this.props.loading}

            selectedTaskId={
              selectedTask
                ? this.getTaskId(selectedTask)
                : null
            }

            onTaskSelect={this.selectTask}

            canPlan={this.props.canPlan}
            onPlanTasks={this.props.onPlanTasks}
          />

          {!selectedTask && (
            <Stack
              spacing={1}
              sx={{ mt: 1.5 }}
            >
              <Typography variant="h6">
                Budget Lines
              </Typography>

              <Alert severity="info">
                Select a Task to inspect its budget lines.
              </Alert>
            </Stack>
          )}

          {selectedTask && (
            <BudgetLineGridPanel
              rows={this.visibleBudgetRows()}
              selectedTask={selectedTask}
              loading={this.props.loading}
            />
          )}
        </Paper>
      </Box>
    );
  }
}

export default ActivityTaskBudgetPanel;